module.exports = __webpack_public_path__ + "img/MoreHeroesNeeded_Back_button.c931e52e.svg";